module.exports = __webpack_public_path__ + "img/gamma.1b0fe198.png";